module.exports = __webpack_public_path__ + "img/lunbo01_02.11d2c183.png";